<template>
    <div id="setup-tab-general-container">
        <MdTitle
            v-bind:Text="$t('PPDbSetup.TabGeneral.EmailToReceive')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />
        <b-row>
            <b-col md="6" lg="6" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.Email')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'contactMessagesEmail'"
                    v-bind:MaxLengthProp="50"
                    v-model="editableItem.contactMessagesEmail"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_contactMessagesEmail'"
                    v-bind:isValid="isEmailValid"
                    v-on:change="emitChanged"
                    v-bind:invalidMessage="$t('Msg.InvalidField')"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('PPDbSetup.TabGeneral.EmailToParent')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col md="4" lg="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.CreatingCredentials')"
                    v-bind:Name="'checkbox-CreatingCredentials'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.sendEmailAfterCreateCredentials"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
            <b-col md="8" lg="8" sm="12">
                <MdSelect
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="messageTypeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.emailNewCredentialsMessageType"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="
                        value => changeDropDownMessageType(value, 'emailNewCredentialsMessageType')
                    "
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4" lg="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.AddingPatientForm')"
                    v-bind:Name="'checkbox-AddingPatientForm'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.sendEmailAfterAddPatientForm"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
            <b-col md="8" lg="8" sm="12">
                <MdSelect
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="messageTypeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.emailPatientFormMessageType"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="
                        value => changeDropDownMessageType(value, 'emailPatientFormMessageType')
                    "
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4" lg="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.FinalizingAShow')"
                    v-bind:Name="'checkbox-FinalizingAShow'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.sendEmailAfterSaveNote"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
            <b-col md="8" lg="8" sm="12">
                <MdSelect
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="messageTypeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.emailNoteMessageType"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="value => changeDropDownMessageType(value, 'emailNoteMessageType')"
                />
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('PPDbSetup.TabGeneral.TextToParent')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col md="4" lg="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.CreatingCredentials')"
                    v-bind:Name="'checkbox-textNewCredentialsMessageType'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.sendTextAfterCreateCredentials"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
            <b-col md="8" lg="8" sm="12">
                <MdSelect
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="messageTypeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.textNewCredentialsMessageType"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="
                        value => changeDropDownMessageType(value, 'textNewCredentialsMessageType')
                    "
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4" lg="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.AddingPatientForm')"
                    v-bind:Name="'checkbox-sendTextAfterAddPatientForm'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.sendTextAfterAddPatientForm"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
            <b-col md="8" lg="8" sm="12">
                <MdSelect
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="messageTypeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.textPatientFormMessageType"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="value => changeDropDownMessageType(value, 'textPatientFormMessageType')"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4" lg="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.FinalizingAShow')"
                    v-bind:Name="'checkbox-sendTextAfterSaveNote'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.sendTextAfterSaveNote"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
            <b-col md="8" lg="8" sm="12">
                <MdSelect
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="messageTypeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.textNoteMessageType"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="value => changeDropDownMessageType(value, 'textNoteMessageType')"
                />
            </b-col>
        </b-row>

        <b-row class="mt-4">
            <b-col sm="12" md="12" lg="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.AddMessageAcivities')"
                    v-bind:Name="'checkbox-addMessagesToPatientActivities'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.addMessagesToPatientActivities"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('PPDbSetup.TabGeneral.TextToParentContact')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col md="4" lg="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.CreatingCredentials')"
                    v-bind:Name="'checkbox-textContactCreateCredentials'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.textContactCreateCredentials"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
            <b-col md="8" lg="8" sm="12">
                <MdSelect
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="messageTypeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.textContactCredentialsMessage"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="
                        value => changeDropDownMessageType(value, 'textContactCredentialsMessage')
                    "
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4" lg="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.AddingPatientForm')"
                    v-bind:Name="'checkbox-textContactAddForm'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.textContactAddForm"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
            <b-col md="8" lg="8" sm="12">
                <MdSelect
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="messageTypeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.textContactAddFormMessage"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="value => changeDropDownMessageType(value, 'textContactAddFormMessage')"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4" lg="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.FinalizingAShow')"
                    v-bind:Name="'checkbox-textContactAddNote'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.textContactAddNote"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
            <b-col md="8" lg="8" sm="12">
                <MdSelect
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="messageTypeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.textContactAddNoteMessage"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="value => changeDropDownMessageType(value, 'textContactAddNoteMessage')"
                />
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('PPDbSetup.TabGeneral.EmailToParentContact')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col md="4" lg="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.CreatingCredentials')"
                    v-bind:Name="'checkbox-emailContactCreateCredentials'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.emailContactCreateCredentials"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
            <b-col md="8" lg="8" sm="12">
                <MdSelect
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="messageTypeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.emailContactCredentialsMessage"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="
                        value => changeDropDownMessageType(value, 'emailContactCredentialsMessage')
                    "
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4" lg="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.AddingPatientForm')"
                    v-bind:Name="'checkbox-emailContactAddForm'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.emailContactAddForm"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
            <b-col md="8" lg="8" sm="12">
                <MdSelect
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="messageTypeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.emailContactAddFormMessage"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="value => changeDropDownMessageType(value, 'emailContactAddFormMessage')"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4" lg="4" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('PPDbSetup.TabGeneral.FinalizingAShow')"
                    v-bind:Name="'checkbox-emailContactAddNote'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="editableItem.emailContactAddNote"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-on:change="emitChanged"
                />
            </b-col>
            <b-col md="8" lg="8" sm="12">
                <MdSelect
                    v-bind:Label="$t('scheduleNotify.mType')"
                    v-bind:Options="messageTypeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="editableItem.emailContactAddNoteMessage"
                    v-bind:Multiple="false"
                    :IsDisabled="this.isReadOnly"
                    :Input="value => changeDropDownMessageType(value, 'emailContactAddNoteMessage')"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'TabGeneral',
    props: {
        value: {
            Type: Object,
            default: null
        },
        isReadOnly: {
            Type: Boolean,
            default: false
        },
        messageTypeList: {
            Type: Array,
            default: () => []
        },
        isEmailValid: {
            Type: Boolean,
            default: true
        }
    },
    data() {
        const defaultItemData = {
            contactMessagesEmail: '',
            sendEmailAfterCreateCredentials: false,
            emailNewCredentialsMessageType: '',
            sendEmailAfterAddPatientForm: false,
            emailPatientFormMessageType: '',
            sendEmailAfterSaveNote: false,
            emailNoteMessageType: '',
            sendTextAfterCreateCredentials: false,
            textNewCredentialsMessageType: '',
            sendTextAfterAddPatientForm: false,
            textPatientFormMessageType: '',
            sendTextAfterSaveNote: false,
            textNoteMessageType: '',
            addMessagesToPatientActivities: false,
            textContactCreateCredentials: false,
            textContactCredentialsMessage: '',
            textContactAddForm: false,
            textContactAddFormMessage: '',
            textContactAddNote: false,
            textContactAddNoteMessage: '',
            emailContactCreateCredentials: false,
            emailContactCredentialsMessage: '',
            emailContactAddForm: false,
            emailContactAddFormMessage: '',
            emailContactAddNote: false,
            emailContactAddNoteMessage: ''
        };

        return {
            editableItem: this.value || defaultItemData,
            defaultItemData: defaultItemData
        };
    },
    watch: {
        value(newVal) {
            this.editableItem = newVal || this.defaultItemData;
        }
    },
    methods: {
        emitChanged() {
            this.$emit('input', this.editableItem);
        },

        changeDropDownMessageType(value, fieldName) {
            this.editableItem[fieldName] = value ? value.value : null;
            this.emitChanged();
        }
    }
};
</script>
